<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            md="8"
                            offset-md="2"
                    >
                      <h1 class="md-display-2 white--text mb-6">{{ $t('headings.Sign up and subscribe') }}</h1>
                      <div v-if="this.loggedIn && e1 === 1">
                        <v-card
                            class="mx-auto form-card"
                            outlined
                        >

                          <v-card-text class="text--primary">
                            <p class="body-1">{{ $t("You are already logged in") }}. {{ $t("Please") }} <router-link
                                :to="{ name: 'logout' }"
                                exact
                            >{{ $t('links.log out') }}</router-link> {{ $t("if you want to sign up as a different user") }}.</p>
                          </v-card-text>
                        </v-card>
                      </div>
                      <div v-else>
                        <v-stepper
                            v-model="e1"
                            vertical
                        >

                          <v-stepper-step
                              :complete="e1 > 1"
                              step="1"
                          >
                            {{ $t("Registration details") }}
                          </v-stepper-step>
                          <v-stepper-content step="1" class="pt-0">
                            <v-card
                                class="mx-auto form-card pt-4"
                                outlined
                            >

                              <v-card-text class="text--primary pt-0">
                                <ValidationObserver ref="observer">
                                  <v-form v-model="valid" @submit.prevent="handleSubmit">

                                    <ValidationProvider vid="name" :name="$t('labels.Name')" rules="required" v-slot="{ errors }">
                                      <v-text-field
                                          v-model="name"
                                          :error-messages="errors[0]"
                                          :label="$t('labels.Name')"
                                          required
                                      ></v-text-field>
                                    </ValidationProvider>

                                    <ValidationProvider vid="email" :name="$t('labels.Email')" rules="required|email" v-slot="{ errors }">
                                      <v-text-field
                                          v-model="email"
                                          :error-messages="errors[0]"
                                          :label="$t('labels.Email')"
                                          required
                                      ></v-text-field>
                                    </ValidationProvider>

                                    <ValidationProvider vid="email_confirmation" :name="$t('labels.Email confirmation')" v-slot="{ errors }" rules="required|confirmed:email">
                                      <v-text-field
                                          v-model="email_confirmation"
                                          :error-messages="errors[0]"
                                          :label="$t('labels.Confirm email')"
                                          required
                                          autocapitalize="none"
                                      ></v-text-field>
                                    </ValidationProvider>


<!--                                      <v-text-field-->
<!--                                          v-model="mobile"-->
<!--                                          :error-messages="errors[0]"-->
<!--                                          :label="$t('labels.Mobile number (digits only)')"-->
<!--                                          required-->
<!--                                          persistent-hint-->
<!--                                          :hint="$t('labels.Required for SMS notifications')"-->
<!--                                      ></v-text-field>-->
                                      <div class="d-flex align-start">
                                        <div style="width: 80px">
                                          <v-autocomplete
                                              class="mr-2"
                                              ref="areaCode"
                                              v-model="area"
                                              :items="countryCodes"
                                              item-text="name"
                                              item-value="code"
                                          >
                                            <template v-slot:selection="data">
                                              <!-- https://github.com/LeCoupa/vueflags/blob/master/flags-->
                                              <span class="select-flag"><gb-flag :code="data.item.lang" size="mini" /></span>
                                            </template>
                                            <template v-slot:item="{ item }">
                                              <!-- https://github.com/LeCoupa/vueflags/blob/master/flags-->
                                              <span class="select-flag"><gb-flag :code="item.lang" size="mini" /><span class="ml-3">{{ item.name }}</span></span>
                                            </template>
                                          </v-autocomplete>
                                        </div>
                                        <div style="width: 100%">
                                          <ValidationProvider vid="mobile" :name="$t('labels.Mobile')" :rules="{ required: true, regex: /^[+][0-9]+$/ }" v-slot="{ errors }">
                                            <v-text-field
                                                v-model="mobile"
                                                :error-messages="errors[0]"
                                                :label="$t('labels.Mobile number (digits only)')"
                                                required
                                                persistent-hint
                                                :placeholder="mobilePlaceholder"
                                                :hint="$t('labels.Required for SMS notifications')"
                                                @input="updateArea(mobile)"
                                            >
                                            </v-text-field>
                                          </ValidationProvider>
                                        </div>
                                      </div>
                                    <h2 class="mt-6 subtitle-1">{{ $t('headings.Organisations') }}</h2>

                                    <ValidationProvider vid="organisation" :name="$t('labels.Organisations')" v-slot="{ errors }">
                                      <v-autocomplete
                                          :items="activeOrganisations"
                                          item-text="name"
                                          item-value="id"
                                          v-model="organisation"
                                          :error-messages="errors[0]"
                                          chips
                                          persistent-hint
                                          clearable
                                          :disabled="organisationSlug !== null"
                                          :hint="$t('hints.Selected organisation can view your name')"
                                      >
                                        <template v-slot:label>
                                          <div>
                                            {{ $t('labels.Primary organisation associated with') }} <small>({{ $t('labels.optional') }})</small>
                                          </div>
                                        </template>
                                      </v-autocomplete>
                                    </ValidationProvider>

                                    <v-divider class="mt-12"></v-divider>

                                    <ValidationProvider vid="terms" :name="$t('labels.Terms')" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
                                      <v-checkbox
                                          v-model="terms"
                                          :error-messages="errors[0]"
                                          required
                                      >
                                        <template v-slot:label>
                                          <div>
                                            {{ $t('labels.I have read the') }}
                                            <v-tooltip bottom>
                                              <template v-slot:activator="{ on }">
                                                <a
                                                    @click.prevent.stop="dialog = true"
                                                    v-on="on"
                                                >
                                                  {{ $t('links.terms and conditions') }}
                                                </a>
                                                <v-dialog
                                                    v-model="dialog"
                                                    max-width="600"
                                                >
                                                  <v-card>
                                                    <v-card-title class="headline">{{ $t('headings.Terms and conditions') }}</v-card-title>

                                                    <v-card-text>
                                                      <TermsContent/>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                      <v-spacer></v-spacer>

                                                      <v-btn
                                                          color="green darken-1"
                                                          text
                                                          @click="rejectTerms"
                                                      >
                                                        {{ $t('buttons.Disagree') }}
                                                      </v-btn>

                                                      <v-btn
                                                          color="green darken-1"
                                                          text
                                                          @click="acceptTerms"
                                                      >
                                                        {{ $t('buttons.Agree') }}
                                                      </v-btn>
                                                    </v-card-actions>
                                                  </v-card>
                                                </v-dialog>
                                              </template>
                                              {{ $t("Opens in popover") }}
                                            </v-tooltip>
                                          </div>
                                        </template>
                                      </v-checkbox>
                                    </ValidationProvider>

                                    <ValidationProvider vid="password" :name="$t('labels.Password')" rules="required|min:8" v-slot="{ errors }">
                                      <v-text-field
                                          v-model="password"
                                          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                          :type="showPassword ? 'text' : 'password'"
                                          :error-messages="errors[0]"
                                          :label="$t('labels.Password')"
                                          required
                                          autocapitalize="none"
                                          @click:append="showPassword = !showPassword"
                                      ></v-text-field>
                                    </ValidationProvider>

                                    <ValidationProvider vid="password_confirmation" :name="$t('labels.Password confirmation')" v-slot="{ errors }" rules="required|min:8|confirmed:password">
                                      <v-text-field
                                          v-model="password_confirmation"
                                          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                          :type="showPassword ? 'text' : 'password'"
                                          :error-messages="errors[0]"
                                          :label="$t('labels.Confirm password')"
                                          required
                                          autocapitalize="none"
                                          @click:append="showPassword = !showPassword"
                                      ></v-text-field>
                                    </ValidationProvider>

                                    <vue-programmatic-invisible-google-recaptcha
                                        ref="invisibleRecaptcha1"
                                        :sitekey="'6Lc1or0UAAAAAHToK0_wzBIEmJSp2BHGNh35DzKL'"
                                        :elementId="'invisibleRecaptcha1'"
                                        :badgePosition="'left'"
                                        :showBadgeMobile="false"
                                        :showBadgeDesktop="true"
                                        @recaptcha-callback="recaptchaCallback"
                                    ></vue-programmatic-invisible-google-recaptcha>

                                    <div class="d-flex justify-end">
                                      <v-btn v-if="recaptchaFailed" @click="resetRecaptcha" color="error">reCAPTCHA failed: reset</v-btn>

                                      <v-btn
                                          color="primary"
                                          @click="handleSubmit"
                                          :loading="loading1"
                                          :disabled="loading1"
                                      >
                                        {{ $t('buttons.Continue') }} <v-icon>mdi-chevron-right</v-icon>
                                        <template v-slot:loader>
                                                            <span class="custom-loader">
                                                              <v-icon light>mdi-loading</v-icon>
                                                            </span>
                                        </template>
                                      </v-btn>
                                    </div>

                                  </v-form>
                                </ValidationObserver>


                              </v-card-text>
                            </v-card>
                          </v-stepper-content>
                          <v-stepper-step
                              :complete="e1 > 2"
                              step="2"
                          >
                            {{ $t("Subscription payment") }}
                          </v-stepper-step>
                          <v-stepper-content step="2" class="pt-0">
                            <v-card
                                class="mx-auto form-card"
                                outlined
                            >

                              <v-card-text class="text--primary">

<!--                                <v-alert-->
<!--                                    v-if="digitalMembership"-->
<!--                                    type="info"-->
<!--                                    color="info"-->
<!--                                    border="left"-->
<!--                                >-->
<!--                                  <v-row align="center">-->
<!--                                    <v-col class="grow pt-0">-->
<!--                                      <div class="text-h6">-->
<!--                                        You are registered with {{ organisationName }}-->
<!--                                      </div>-->
<!--                                      <div>You can skip this step, as your organisation does not require a subscription for the kit they will provide. You can subscribe at a later date if you wish to buy additional tags.</div>-->
<!--                                    </v-col>-->
<!--                                    <v-col class="shrink">-->
<!--                                      <v-btn outlined @click="e1 = 3">{{ $t('buttons.Skip') }}</v-btn>-->
<!--                                    </v-col>-->
<!--                                  </v-row>-->

<!--                                </v-alert>-->

                                <v-alert
                                    v-if="freeSampleCta"
                                    type="info"
                                    color="info"
                                    border="left"
                                >
                                  <v-row align="center">
                                    <v-col class="grow pt-0">
                                      <div class="text-h6">
                                        {{ $t("Intro membership?") }}
                                      </div>
                                      <div>{{ $t("You can skip this step if you only want to activate your intro membership") }}.</div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-btn outlined @click="e1 = 3">{{ $t('buttons.Skip') }}</v-btn>
                                    </v-col>
                                  </v-row>

                                </v-alert>

                                <div v-if="coupon">
                                  <v-alert type="success">{{ $t("Promotion added") }}</v-alert>
                                  <p class="text-h2 text-center">{{subscriptionDiscount}}<span class="text-overline ml-3">{{ $t('headings.first years subscription') }}</span> <span class="text-h4"><span class="red--text" style="text-decoration: line-through">{{ subscriptionPriceWithCurrency }}</span> {{ brand === 'neotag' ? '€' : '£'}}{{ reducedPrice }}</span></p>
                                  <p class="body-1">{{ $t("Please enter your card details below for your annual subscription") }}.</p>
                                  <p class="body-1 red--text" v-if="coupon.amount_off === 2500">{{ $t("We still need to take your payment details now to activate your subscription") }}. {{ $t("No payment will be taken until next years renewal") }}. {{ $t("You can cancel your subscription at any time") }}.</p>
                                </div>

                                <div v-else>
                                  <p class="text-h2 text-center"><span class="text-overline">first years subscription</span> <span class="text-h4">{{ subscriptionPriceWithCurrency }}</span></p>
                                  <p class="body-1">{{ $t("If you have a promotional code please validate it here, before you enter your payment details") }}.</p>

                                  <ValidationObserver ref="promoObserver">
                                    <ValidationProvider vid="promo_code" :name="$t('labels.Promo code')" v-slot="{ errors }">
                                      <div class="d-flex align-top">
                                        <v-text-field
                                            v-model="promo_code"
                                            :error-messages="errors[0]"
                                            type="text"
                                            filled
                                            dense
                                            max-width="200px"
                                            prepend-icon="mdi-ticket-percent"
                                            :label="$t('labels.Promotional code')"
                                            :loading="validatingPromo"
                                            class="align-self-center"
                                        >
                                          <template v-slot:append>
                                            <v-icon v-if="promoValid" color="green">mdi-check-bold</v-icon>
                                          </template>
                                        </v-text-field>
                                        <v-btn class="ml-1" color="primary" elevation="0" height="53" @click="validatePromo">{{ $t('buttons.Validate') }} <v-icon color="white">mdi-chevron-right</v-icon></v-btn>
                                      </div>

                                    </ValidationProvider>
                                  </ValidationObserver>
                                  <p class="body-1">{{ $t("Please enter your card details below for your {subscription} annual subscription", {subscription: subscriptionPriceWithCurrency}) }}.</p>
                                </div>

                                <div ref="card"></div>

                                <v-btn
                                    class="mt-4"
                                    tile
                                    block
                                    elevation="0"
                                    color="primary"
                                    @click='pay'
                                    :loading="loading2"
                                    :disabled='stripeDialog === true || loading2'
                                >
                                  Pay with card
                                  <v-icon>mdi-lock</v-icon>
                                  <template v-slot:loader>
                                                            <span class="custom-loader">
                                                              <v-icon light>mdi-loading</v-icon>
                                                            </span>
                                  </template>
                                </v-btn>

                                <div class="d-flex align-center flex-column justify-center mt-6">
                                  <v-icon color="primary" x-large class="mt-3">mdi-gift</v-icon>
                                  <p class="text-center">
                                    {{ $t("We will then send your products bundle worth {price} in the post shortly", {price: bundlePrice}) }}
                                  </p>
                                </div>



                              </v-card-text>



                            </v-card>
                          </v-stepper-content>
                          <v-stepper-step
                              step="3"
                          >
                            {{ $t("Verify email address") }}
                          </v-stepper-step>
                          <v-stepper-content step="3" class="pt-0 pl-0">
                            <v-card
                                class="mx-auto form-card"
                                outlined
                            >


                              <v-card-text class="text--primary">

                                <p class="headline">{{ $t('headings.Please verify your email address') }}</p>
                                <p>{{ $t("Please check your inbox for an email we sent to {email} from {support}", {email: email, support: supportEmail}) }}</p>
                                <p>{{ $t("You will need to confirm your email address before you can access all website features") }}.</p>
                                <p>{{ $t("Please make sure you are logged in on the same device and browser, that the email link opens in") }}.</p>

                              </v-card-text>
                            </v-card>
                          </v-stepper-content>

                        </v-stepper>
                      </div>



                    </v-col>

                </v-row>
            </v-container>
        </v-container>
        <Footer />
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">{{ $t('buttons.Close') }}</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex'

    import { store } from '../store';
    import axios from 'axios';

    import { extend } from 'vee-validate';
    import { required, email, integer, confirmed, regex } from 'vee-validate/dist/rules';

    import Footer from './Footer'
    import TermsContent from './TermsContent'

    import { stripeService, userService } from '../services'
    import {i18n} from "../i18n";

    extend('regex', {
      ...regex,
      message: "{_field_} should be numbers only, without spaces"
    });

    extend('confirmed', confirmed);

    // Add the required rule
    extend('required', required);

    // Add the email rule
    extend('email', email);

    extend('lengthBetween', {
        validate: (value, { min, max }) => {
            const length = value && value.length;

            return length >= min && length <= max;
        },
        params: ['min', 'max'],
        message: i18n.t('The {_field_} length must be between {min} and {max} digits')
    });

    // Add the min rule
    extend('min', {
        validate: (value, { min }) => {
            const length = value && value.length;

            return length >= min;
        },
        params: ['min'],
        message: i18n.t('Please enter a minimum of {min} characters')
    });

    // Add the min rule
    extend('integer', integer);

    const stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY, {locale: i18n.locale === 'es' ? 'es' : 'en'});

    export default {
        name: "RegisterIndividual",
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Sign up as an individual'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('Sign up as an individual if you wish to buy tags for yourself, friends, family, dependants and anyone we have not mentioned!') }
            ]
          }
        },
        components: {
            'Footer': Footer,
            'TermsContent': TermsContent
        },
        data: () => ({
            promo_code: '',
            promoValid: false,
            validatingPromo: false,
            coupon: null,
            dialog: false,
            mountStripeElement: false,
            stripeKey: process.env.VUE_APP_STRIPE_KEY,
            complete: false,
            declined: false,
            stripeOptions: {
                // see https://stripe.com/docs/stripe.js#element-options for details
                style: {
                    base: {
                        color: '#32325d',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#aab7c4'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                }
            },
            subscriptionCard: null,
            stripeDialog: false,
            loader: null,
            loading1: false,
            loading2: false,
            e1: 1,
            snack: false,
            snackColor: '',
            snackText: '',
            name: '',
            email: '',
            email_confirmation: null,
            area: '',
            mobile: '',
            address1: null,
            address2: null,
            town: null,
            county: null,
            postcode: null,
            country: null,
            password: '',
            password_confirmation: null,
            organisation: null,
            makeTagsPublic: true,
            terms: false,
            submitted: false,
            valid: false,
            showPassword: false,
            recaptchaFailed: false,
            activeOrganisations: [],
            freeProduct: null,
            clientSecret: null,
            elements: null,
            card: null
        }),
        watch: {
          area(val) {
            if (val !== '') {
              console.log(val)
              this.mobile = val
              this.$refs.areaCode.blur();
            }
          }
        },
        mounted () {

            this.$gtag.pageview({
                page_path: '/register-individual'
            })

            document.getElementById("scrolling-content").scrollTop = 0

            this.mountStripeElement = true;

            // if (this.$router.currentRoute.query.organisation) {
            //     this.organisationSlug = this.$router.currentRoute.query.organisation
            // }

            const instance = axios.create({
              baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
              headers: {'Accept-Language': i18n.locale}
            });

            instance
                .get('/api/organisations/enabled?brand=' + this.brand)
                .then(response => {
                    if (response.status === 200) {
                        this.activeOrganisations = response.data.data
                        console.log(this.activeOrganisations)

                        if (this.$router.currentRoute.query.organisation) {
                            this.referringOrganisation(this.$router.currentRoute.query.organisation).then(() => {
                                for (let x in this.activeOrganisations) {
                                    if (this.activeOrganisations[x].slug && this.organisationSlug && this.activeOrganisations[x].slug === this.organisationSlug) {
                                        this.organisation = this.activeOrganisations[x]
                                        if (this.organisation.coupon) {
                                          this.coupon = this.organisation.coupon
                                        }
                                    }
                                }
                            })
                        }
                        else {
                            for (let x in this.activeOrganisations) {
                                if (this.activeOrganisations[x].slug && this.organisationSlug && this.activeOrganisations[x].slug === this.organisationSlug) {
                                    this.organisation = this.activeOrganisations[x]
                                    if (this.organisation.coupon) {
                                      this.coupon = this.organisation.coupon
                                    }
                                }
                            }
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    this.show = true
                    window.prerenderReady = true;
                })



              instance
                  .get('/api/products/slug/free-bundle' )
                .then(response => {
                    this.freeProduct = response.data.data
                })
                .catch(error => {
                    console.log(error)
                })

            // if (this.promoCode) {
            //   axios
            //       .post(process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST + '/api/stripe/validate-promo-code', {
            //         promo_code: this.promoCode
            //       })
            //       .then(response => {
            //         if (response.status === 200) {
            //           this.promoValid = true
            //           this.coupon = response.data.coupon
            //           console.log(response.data.coupon)
            //         }
            //       })
            //       .catch(error => {
            //         console.log(error)
            //         if (error.response.status === 404) {
            //
            //           this.$refs.promoObserver.setErrors(error.response.data.errors);
            //
            //         }
            //
            //
            //       })
            //       .finally(() => {
            //         this.validatingPromo = false
            //       })
            // }
        },
        methods: {
            ...mapActions('account', ['register', 'updateMembership', 'updateSubscription']),
            ...mapActions('basket', ['addSilent']),
            ...mapActions(['referringOrganisation']),
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            updateArea(mobile) {
                if (mobile.length === 1 && mobile.substring(0, 1) !== '+') {
                  this.mobile = '+' + this.mobile
                }

                if (mobile.substring(0, 1) === '+' && mobile.length >= 3) {
                  let prefix = mobile.substring(0, 3)

                  let area = this.countryCodes.find( record => record.code === prefix)
                  if (area) {
                    this.area = area.code
                  }
                  else {
                    let prefix = mobile.substring(0, 4)

                    let area = this.countryCodes.find( record => record.code === prefix)
                    if (area) {
                      this.area = area.code
                    }
                  }
                }
            },
            validatePromo() {

              // remove errors
              this.$refs.promoObserver.reset();

              this.validatingPromo = true
              this.promoValid = false
              this.coupon = null

              const instance = axios.create({
                baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST
              });

              instance
                  .post('/api/stripe/validate-promo-code', {
                    promo_code: this.promo_code
                  })
                  .then(response => {
                    if (response.status === 200) {
                      this.promoValid = true
                      this.coupon = response.data.coupon
                      console.log(response.data.coupon)
                    }
                  })
                  .catch(error => {
                    console.log(error)
                    if (error.response.status === 404) {

                      this.$refs.promoObserver.setErrors(error.response.data.errors);

                    }


                  })
              .finally(() => {
                this.validatingPromo = false
              })

            },
            acceptTerms() {
              this.dialog = false
              this.terms = true
            },
            rejectTerms() {
              this.dialog = false
              this.terms = false
            },
            handleSubmit () {
                this.submitted = true;



                this.$refs.observer.validate().then(success => {
                    if (this.valid) {

                        this.loader = 'loading1'
                        this.loading1 = true

                        const {name, email, email_confirmation, mobile, password, password_confirmation} = this;

                        if (name && email, email_confirmation && mobile && password && password_confirmation) {

                            this.$refs.invisibleRecaptcha1.execute()
                        }
                    }
                }).catch(error => {
                    console.log(error)
                    this.recaptchaFailed = true;
                    this.loader = null
                    this.loading1 = false
                })
            },
            recaptchaCallback (recaptchaToken) {

                let that = this
                console.log(that.card)

                const { name, email, email_confirmation, mobile, password, password_confirmation, organisation, address1, address2, town, county, postcode, country, makeTagsPublic, terms, brand } = this;
                if (name && email && email_confirmation && mobile && password && password_confirmation && recaptchaToken && terms) {

                    let organisations = [];
                    if (organisation) {
                        organisations[0] = organisation
                    }

                    this.register({ name, email, email_confirmation, mobile, address1, address2, town, county, postcode, country, password, password_confirmation, organisations, makeTagsPublic, recaptchaToken, terms, brand}).then(user => {

                        if (!user) {

                            // Add the server side errors for each field.
                            this.$refs.observer.setErrors(store.getters.validationErrors);

                            if (store.getters.validationErrors['recaptchaToken']) {
                                console.log("recaptchaFailed")
                                this.recaptchaFailed = true;
                            }

                        }

                        else {

                            document.getElementById("scrolling-content").scrollTop = 0
                            this.e1 = 2

                            stripeService.subscriptionIntent().then(intent => {
                              this.clientSecret = intent.client_secret
                              console.log(this.clientSecret)

                              const options = {
                                clientSecret: this.clientSecret,
                                // Fully customizable with appearance API.
                                appearance: {
                                  theme: this.brand === 'neotag' ? 'night' : 'default'
                                }
                              };

                              this.elements = stripe.elements(options);

                              this.card = this.elements.create('payment');
                              this.card.mount(this.$refs.card);
                            })

                        }

                        this.loader = null
                        this.loading1 = false

                    })
                }
            },
            resetRecaptcha () {
                this.$refs.invisibleRecaptcha1.reset()
                this.recaptchaFailed = false;
            },
            navigate(routeName) {
                this.$router.push({name: routeName})
            },
            pay() {
                this.stripeDialog = true

                let that = this

                this.loader = 'loading2'
                this.loading2 = true

                let elements = this.elements
                stripe.confirmSetup(
                    {
                      elements,
                      redirect: 'if_required'
                    }
                ).then(function(result) {
                  // Handle result.error or result.paymentIntent
                  console.log(result)

                  if (result.error) {
                    console.log(result.setupIntent)
                    this.error = true
                  } else {

                    let couponId = that.coupon ? that.coupon.id : null;

                    stripeService.confirmSubscription(result.setupIntent.payment_method, couponId, that.brand).then(response => {
                      console.log(response)
                      that.stripeDialog = false

                      //this.user = response.data.data

                      let subscription = response.data.stripe_subscription
                      let product = that.freeProduct

                      that.updateSubscription(subscription).then(() => {
                        that.updateMembership(true).then(() => {
                          return that.addSilent({product}).then(() => {
                            console.log('added')

                            store.dispatch('alert/gift', i18n.t('Your subscription is now active') + '. ' + i18n.t('We have popped a FREE bundle in your basket') + '.' + i18n.t('Please checkout to claim') + '.', { root: true });

                            that.loading2 = false
                            that.e1 = 3

                          })
                        })
                      })


                    })
                  }
                }).catch(function (error) {
                  console.log(error)
                  that.stripeDialog = false
                });
            },
            clearCard () {
                this.$refs.subscriptionCard.clear() // "card" reference is defined in template above
            },
        },
        computed: {
            ...mapGetters('account', ['loggedIn']),
            ...mapState({
                user: state => state.account.user,
                organisationSlug: state => state.referringOrganisation,
                promoCode: state => state.promoCode,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            digitalMembership() {
              if (this.user.organisations && this.user.organisations[0]) {
                return this.user.organisations[0].digital_membership
              }

              return false
            },
            organisationName() {
                if (this.user.organisations) {
                  return this.user.organisations[0].name
                }

                return null
            },
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            supportEmail() {
              if (this.brand === 'neotag') {
                return 'info@neotag.com'
              }
              else {
                return 'support@findmykit.com'
              }
            },
            mobilePlaceholder() {
                if (this.brand === 'neotag') {
                  return '+34 000 000 000'
                }
                else {
                  return '+44 00000 000 000'
                }
            },
            countryCodes() {
              return [
                {
                  name: 'United Kingdom +44',
                  lang: 'gb',
                  code: '+44'
                },
                {
                  name: 'United States +1',
                  lang: 'us',
                  code: '+1'
                },
                {
                  name: 'Spain +34',
                  lang: 'es',
                  code: '+34'
                },
                {
                  name: 'France +33',
                  lang: 'fr',
                  code: '+33'
                },
                {
                  name: 'Italy +39',
                  lang: 'it',
                  code: '+39'
                },
                {
                  name: 'Portugal +351',
                  lang: 'pt',
                  code: '+351'
                }
              ]
            },
            countriesList () {
              return [
                {name: i18n.t('United Kingdom'), code: 'GB'},
                {name: i18n.t('Singapore'), code: 'SG'},
                {name: i18n.t('Spain'), code: 'ES'},
                {name: i18n.t('United States'), code: 'US'},
              ]
            },
            subscriptionDiscount() {
              if (this.coupon) {

                if (this.brand === 'neotag') {
                  if (this.coupon.amount_off === (process.env.VUE_APP_SUBSCRIPTION_EUR * 100)) {
                    return 'FREE '
                  }

                  // let discount = this.organisation.coupon.amount_off / 100
                  // return ((discount / process.env.VUE_APP_SUBSCRIPTION_EUR) * 100) + '% off '
                  return '€' + (this.coupon.amount_off / 100) + ' ' + i18n.t('off')
                }
                else {
                  if (this.coupon.amount_off === (process.env.VUE_APP_SUBSCRIPTION_GBP * 100)) {
                    return 'FREE '
                  }

                  // let discount = this.organisation.coupon.amount_off / 100
                  // return ((discount / process.env.VUE_APP_SUBSCRIPTION_GBP) * 100) + '% off '
                  return '£' + (this.coupon.amount_off / 100) + ' ' + i18n.t('off')
                }
              }
              return null
            },
            subscriptionPrice() {
              if (this.brand === 'neotag') {
                return process.env.VUE_APP_SUBSCRIPTION_EUR
              }

              return process.env.VUE_APP_SUBSCRIPTION_GBP
            },
            subscriptionPriceWithCurrency() {
              if (this.brand === 'neotag') {
                return '€' + process.env.VUE_APP_SUBSCRIPTION_EUR
              }

              return '£' + process.env.VUE_APP_SUBSCRIPTION_GBP
            },
            reducedPrice() {
              if (this.coupon) {
                return ((this.subscriptionPrice * 100) - this.coupon.amount_off) / 100
              }
              return null
            },
            freeSampleCta() {
              let dataNow = new Date()
              let dateStart = new Date('2022-03-21T01:00:00Z');
              let dateEnd = new Date('2022-03-27T11:00:00Z');
              let isBetween = false;
              console.log(dataNow.getTime())
              console.log(dateEnd.getTime())
              console.log(dateStart.getTime())
              if((dataNow.getTime() <= dateEnd.getTime() && dataNow.getTime() >= dateStart.getTime())) {
                isBetween = true;
              }

              if (this.coupon && !isBetween) {
                return false
              }

              return true
            },
            bundlePrice() {
              if (this.brand === 'neotag') {

                return '€' + process.env.VUE_APP_BUNDLE_EUR
              }

              return '£' + process.env.VUE_APP_BUNDLE_GBP
            }
        }
    }
</script>

<style scoped>
    button {
        text-transform: none;
    }
    .product-card {
        border-radius: 15px 15px 0 0;
        border: none !important;
    }
    .stripe-card {
        /*width: 300px;*/
        border: 1px solid grey !important;
        box-sizing: border-box;

        height: 40px;

        padding: 10px 12px;
        margin: 20px 0;

        border: 1px solid transparent;
        border-radius: 4px !important;
        background-color: white;

        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
    }
    .stripe-card.complete {
        border-color: green !important;
    }
    .stripe-card.complete.declined {
        border-color: red !important;
    }

    .stripe-card--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .stripe-card--invalid {
        border-color: #fa755a;
    }

    .stripe-card--webkit-autofill {
        background-color: #fefde5 !important;
    }

    .pay-with-stripe {
        display: block;
        background: #666ee8;
        color: #000;
        box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        border: 0;
        font-weight: 700;
        width: 100%;
        height: 40px;
        outline: none;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .pay-with-stripe:focus {
        background: #555abf;
    }

    .pay-with-stripe:hover {
        transform: translateY(-1px);
        box-shadow: 0 7px 14px 0 rgba(50, 50, 93, 0.1),
        0 3px 6px 0 rgba(0, 0, 0, 0.08);
    }

    .clear-button {
        margin-top: 20px;
    }
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>
